export default __webpack_public_path__ + "static/media/ff_pt.33bc0546.png";